import Vue from 'vue'
import axios from 'axios'
import { storeToRefs } from 'pinia'
import useAuthStore from '@/store/auth'

const axiosSecurity = axios.create({
  baseURL: process.env.VUE_APP_SECURITY,
  // baseURL: 'https://localhost:5000/api/',
})

axiosSecurity.interceptors.request.use(
  config => {
    const { accessToken } = storeToRefs(useAuthStore())

    if (!accessToken.value) return config
    return { ...config, headers: { Authorization: `Bearer ${accessToken.value}` } }
  },
  error => Promise.reject(error),
)

axiosSecurity.interceptors.response.use(
  response => {
    if (!['post', 'put', 'delete'].includes(response.config.method)) return response

    Vue.$toast.clear()
    Vue.$toast.success(response.data.message)

    return response
  },
  async error => {
    const { status, data: { message } } = error.response

    if (status === 400 || status === 422) {
      Vue.$toast.warning(message)
    } else if (status === 500) {
      Vue.$toast.error(message)
    }

    return Promise.reject(error)
  },
)

export default axiosSecurity
